import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { CartService } from '../../cart/cart.service';

@Injectable()
export class AddressGuard implements CanActivate {
  constructor(private cartService: CartService) {}

  canActivate() {
    return this.cartService.getTicketAmount() > 0 ? true : false;
  }
}
